'use client';

import Image from '@/components/image';
import NextLink from '@/components/next-link';
import { usePathname } from '@/i18n/navigation';
import { event_button_click, event_change_lang } from '@/utils/gtm';
import { useLocale } from 'next-intl';
import { useSearchParams } from 'next/navigation';

export default function LocaleSwitcher({
  fromTopHeader,
  className = '',
  title = '',
}) {
  const locale = useLocale();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const queryString = searchParams.toString();
  const newPath = queryString ? `${pathname}?${queryString}` : pathname;

  if (fromTopHeader)
    return (
      <NextLink
        aria-label='Language'
        onClick={() => {
          event_change_lang({ locale: locale === 'ar' ? 'en' : 'ar' });
          event_button_click({
            button_name: locale === 'ar' ? 'English' : 'Arabic',
            button_destination: newPath,
            button_location: 'top_header',
          });
        }}
        locale={locale === 'ar' ? 'en' : 'ar'}
        href={newPath}
        className='flex flex-col'
      >
        <span className='block h-5 w-8 sm:w-8.5 md:w-9.5'>
          <Image
            loading='lazy'
            src={
              locale === 'en'
                ? '/imgs/layout/ksa-top-header.png'
                : '/imgs/layout/usa-flag.png'
            }
            className='rounded-sm object-cover'
            alt='KSA Flag'
          />
        </span>
        <span className='text-center text-[8px] sm:text-[10.5px] md:text-xs'>
          {locale === 'en' ? 'العربيه' : 'English'}
        </span>
      </NextLink>
    );

  return (
    <div className={className}>
      <NextLink
        aria-label='Language'
        onClick={() => {
          event_change_lang({ locale: locale === 'ar' ? 'en' : 'ar' });
          event_button_click({
            button_name: locale === 'ar' ? 'English' : 'Arabic',
            button_destination: newPath,
            button_location: 'header',
          });
        }}
        className='cursor-pointer text-[10.5px] sm:text-[15.5px]'
        locale={locale === 'ar' ? 'en' : 'ar'}
        href={newPath}
      >
        {title || (locale === 'ar' ? 'English' : 'العربيه')}
      </NextLink>
    </div>
  );
}
